import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../../config/authAxios";
import apiRoutes from "../../apiConfigs";

export const addEventModuleSettingsApi = createAsyncThunk(
  "auth/teacher-lounge/addEventModuleSettings",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(
        apiRoutes.publicapiAction(`events_setting`, 1),
        data
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const addEventModuleSettingsSlice = createSlice({
  name: "addEventModuleSettings",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(addEventModuleSettingsApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addEventModuleSettingsApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(addEventModuleSettingsApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const addEventModuleSettingsReducer = addEventModuleSettingsSlice.reducer;
